<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="close()" ></ion-back-button>
    </ion-buttons>
    <ion-title>Vorgangsdetails {{process?.number}}</ion-title>

    @if(wawiConnectorSrv.connector.executable){
      <ion-buttons slot="end" [title]="'In ' + wawiConnectorSrv.appName + ' öffnen'">
        <ion-button (click)="openProcess()">
          <ion-icon slot="icon-only" name="wawitogo"></ion-icon>
        </ion-button>
      </ion-buttons>
    }

  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h2 style="margin-top: 15px;">Vorgangsdetails</h2>
  <div id="process-header">
    <div id="process-detail-left">
      <div class="process-detail-left-item">
        <div>VorgangsNr.:</div>
        <div>{{process?.number || "-"}}</div>
      </div>
      <div class="process-detail-left-item">
        <div>Betrag:</div>
        <div>{{process?.amount | currency}}</div>
      </div>
      @if (process.type?.id == 4 && !process.canceled) {
        <div class="process-detail-left-item">
          <div>Bezahlt:</div>
          <div>
            @switch(process.payState){
              @case('PAID') { <span class="process-text-colored process-text-green">Bezahlt</span> }
              @case('OPEN'){ <span class="process-text-colored process-text-red">Unbezahlt</span> }
              @case('PARTLY_PAID'){ <span class="process-text-colored process-text-yellow"> Teilweise bezahlt </span> }
            }
          </div>
        </div>
      }
      <div class="process-detail-left-item">
        <div>Datum:</div>
        <div>{{process.date | date : 'dd.MM.yyyy'}}</div>
      </div>
    </div>

    <div id="process-detail-right">
      <div class="process-detail-chip process-detail-right-type">{{process.type.name}}</div>
    </div>
  </div>

  <h2>Positionen</h2>


  @if(isLoading){
    <section id="loading">
      <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
    </section>
  }
  @else if(positions.length == 0){
  <p class="no-content">Keine Positionen vorhanden</p>
}
@else {
<div id="process-positions">
  @for (pos of positions; track pos) {
    <div class="process-position-item">
      <div class="process-position-item-header">
        <div class="process-detail-chip process-position-item-chip">{{pos.art?.description}}</div>
        <div class="process-position-item-pos">Pos.: {{pos?.position}}</div>
      </div>
      <h3>{{pos?.description}}</h3>
      <div class="process-position-item-value">Einzelpreis: {{pos?.price | currency}}</div>
      <div class="process-position-item-value">Anzahl: {{pos?.amount}}</div>
      <div class="process-position-item-value">Gesamt: {{pos?.priceTotal | currency}}</div>
      @if (pos?.positionText) {
        <div class="process-position-item-note" [innerHTML]="pos?.positionText | safeHtml"></div>
      }
    </div>
  }
</div>
}

</ion-content>
